import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import completionTick from "../../../assets/images/completion.svg";
import Footer from "../../commonComponents/footer/Footer.js";
import thankYouImg from "../../../assets/images/nh_consumer_success.svg";
import useAudioRecording from "../meeting/components/useAudioRecording.js";
import Header from "../../commonComponents/header/Header.js";
import { useNavigate } from "react-router-dom";
import arrowWhiteImg from "../../../assets/images/arrow-white-icon.svg";
const AssessmentSuccess = () => {
  const { stopRecording, cleanup } = useAudioRecording();
  const navigate = useNavigate();
  // const surveyFeedback = sessionStorage.getItem("surveyFeedback") === "true";

  useEffect(() => {
    const preserved = {
      interviewId:
        sessionStorage.getItem("interviewId") ||
        localStorage.getItem("interviewId"),

      companyId:
        sessionStorage.getItem("companyId") ||
        localStorage.getItem("companyId"),
      refreshToken:
        sessionStorage.getItem("refreshToken") ||
        localStorage.getItem("refresh_token") ||
        sessionStorage.getItem("interviewRefreshToken"),
      authToken:
        sessionStorage.getItem("authToken") ||
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("auth_token") ||
        localStorage.getItem("auth_token") ||
        sessionStorage.getItem("access_token") ||
        localStorage.getItem("access_token"),
      // surveyFeedback: sessionStorage.getItem("surveyFeedback"),
    };

    // clear all storage
    sessionStorage.clear();
    localStorage.clear();

    // restore preserved values back
    if (preserved.interviewId)
      sessionStorage.setItem("interviewId", preserved.interviewId);

    if (preserved.companyId)
      sessionStorage.setItem("companyId", preserved.companyId);

    if (preserved.authToken) {
      // store in same key you use across app
      sessionStorage.setItem("authToken", preserved.authToken);
      sessionStorage.setItem("access_token", preserved.authToken);
      localStorage.setItem("access_token", preserved.authToken);
      sessionStorage.setItem("interviewAuthToken", preserved.authToken);
    }
    if (preserved.refreshToken) {
      // store in same key you use across app
      sessionStorage.setItem("refreshToken", preserved.refreshToken);
      sessionStorage.setItem("interviewRefreshToken", preserved.refreshToken);
      localStorage.setItem("refresh_token", preserved.refreshToken);
    }
    // if (preserved.surveyFeedback) {
    //   sessionStorage.setItem("surveyFeedback", preserved.surveyFeedback);
    // }
    stopRecording();
    cleanup();

    // Prevent back navigation only
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = () => window.history.go(1);

    const preventKey = (e) => {
      if (
        e.key === "Backspace" &&
        e.target.tagName !== "INPUT" &&
        e.target.tagName !== "TEXTAREA"
      ) {
        e.preventDefault();
      }
    };

    window.addEventListener("keydown", preventKey);
    let timer;

    timer = setTimeout(() => {
      navigate("/survey");
    }, 5000);

    return () => {
      window.removeEventListener("keydown", preventKey);
      window.onpopstate = null;
      clearTimeout(timer);
    };
  }, [stopRecording, cleanup]);

  return (
    <div className="fixed inset-0 bg-white flex flex-col z-[9999] assement-font-color p-[16px]">
      <Header />
      <div className="flex-1 flex">
        {/* Left Side - Illustration */}
        <div className="flex-1 flex items-center justify-center pl-[34px] pr-[50px]">
          <img
            src={thankYouImg}
            alt="Thank you illustration"
            className="w-[100%] h-auto rounded-3xl"
          />
        </div>

        {/* Divider */}
        <div className="hidden md:block border-l border-dividerColor my-[5%]" />

        {/* Right Side - Content */}
        <div className="flex-1 flex items-center justify-center px-1">
          <div className="max-w-3xl w-full text-center">
            <h1 className="text-3xl font-medium text-gray-900 mb-6 assement-font-color assessment-first-font">
              Assessment Complete!
            </h1>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-center"
            >
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <img
                  src={completionTick}
                  alt="Completion Tick"
                  className="w-14 h-14"
                />
              </div>
              <p className="mb-6 assessment-second-font">
                Processing complete. Your session is now closed!
              </p>

              <div className="flex justify-center mt-4">
                <button
                  onClick={() => navigate("/survey")}
                  className="flex items-center px-6 py-1.5 btn-size transition-colors duration-200 bg-btnBgColor text-white"
                >
                  Continue to Survey
                  <img src={arrowWhiteImg} alt="arrow" className="ml-2" />
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AssessmentSuccess;
